import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import c from "../common/event-logger.js";
import r from "../managers/braze-instance.js";
import { keys as C } from "../util/code-utils.js";
import i from "./banner-provider-factory.js";
export function logBannerImpressions(o) {
  if (!r.rr()) return;
  if (!o || o.length <= 0) return !1;
  var n = i.o(),
    s = n.ht();
  if (0 === C(s).length) return E.info("Not logging banners impression. No banners exist."), !1;
  var e = n.Tt(),
    t = [];
  var _iterator = _createForOfIteratorHelper(o),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _r = _step.value;
      var _o = s[_r];
      _o ? e[_o.placementId] ? E.info("Not logging banners impression for ID ".concat(_r, ". This ID was already logged this session.")) : (e[_o.placementId] = !0, t.push(_o.id)) : E.info("Not logging banners impression for ID ".concat(_r, ". The placement ID did not correspond to any banner."));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (0 === t.length) return !1;
  n.Rt(e);
  var a = {
    ids: t
  };
  return c.rt(m.ro, a).W;
}